/*
 *
 * DownloadReport constants
 *
 */

import { ICON_NAME } from 'components/CustomIcons/types';
import { RISK_TRANSACTIONS } from 'components/GenerateReportModal/constants';

const BASE_ACTION_CONSTANT = 'app/DownloadReport';

export const DEFAULT_ACTION = `${BASE_ACTION_CONSTANT}/DEFAULT_ACTION`;

export const ENABLE_LOADER = `${BASE_ACTION_CONSTANT}/ENABLE_LOADER`;

export const DISABLE_LOADER = `${BASE_ACTION_CONSTANT}/DISABLE_LOADER`;

export const SEARCH_GENERATED_REPORTS = `${BASE_ACTION_CONSTANT}/SEARCH_GENERATED_REPORTS`;

export const UPDATE_TABLE_DATA = `${BASE_ACTION_CONSTANT}/UPDATE_TABLE_DATA`;

export const UPDATE_FILTERS = `${BASE_ACTION_CONSTANT}/UPDATE_FILTERS`;

export const RESET_FILTERS = `${BASE_ACTION_CONSTANT}/RESET_FILTERS`;

export const RESET_DATA = `${BASE_ACTION_CONSTANT}/RESET_DATA`;

export const SAVE_REPORTS = `${BASE_ACTION_CONSTANT}/SAVE_REPORTS`;

export const GET_REPORT_BY_ID = `${BASE_ACTION_CONSTANT}/GET_REPORT_BY_ID`;

export const HANDLE_GET_REPORT_BY_ID_RESPONSE = `${BASE_ACTION_CONSTANT}/HANDLE_GET_REPORT_BY_ID_RESPONSE`;

export const DOWNLOAD_REPORT = `${BASE_ACTION_CONSTANT}/DOWNLOAD_REPORT`;

export const HANDLE_DOWNLOAD_REPORT_RESPONSE = `${BASE_ACTION_CONSTANT}/HANDLE_DOWNLOAD_REPORT_RESPONSE`;

export const DELETE_REPORT = `${BASE_ACTION_CONSTANT}/DELETE_REPORT`;

export const HANDLE_DELETE_REPORT_RESPONSE = `${BASE_ACTION_CONSTANT}/HANDLE_DELETE_REPORT_RESPONSE`;

export const GENERATE_REPORT = `${BASE_ACTION_CONSTANT}/GENERATE_REPORT`;

export const GET_VENDOR_RECON_REPORT = `${BASE_ACTION_CONSTANT}/GET_VENDOR_RECON_REPORT`;

export const GET_VENDOR_ORDER_RECON_REPORT = `${BASE_ACTION_CONSTANT}/GET_VENDOR_ORDER_RECON_REPORT`;

export const HANDLE_GENERATE_REPORT_RESPONSE = `${BASE_ACTION_CONSTANT}/HANDLE_GENERATE_REPORT_RESPONSE`;

export const RESET_PAGE = `${BASE_ACTION_CONSTANT}/RESET_PAGE`;

export const RESET_MODAL = `${BASE_ACTION_CONSTANT}/RESET_MODAL`;

export const SEARCH_VENDOR_RECON_SETTLEMENT_SPECIFIC_REPORT = `${BASE_ACTION_CONSTANT}/SEARCH_VENDOR_RECON_SETTLEMENT_SPECIFIC_REPORT`;

export const HANDLE_NEW_REPORT_STATUS = `${BASE_ACTION_CONSTANT}/HANDLE_NEW_REPORT_STATUS`;

export const MERCHANT_ROUTES = `${BASE_ACTION_CONSTANT}/MERCHANT_ROUTES`;

export const MERCHANT_RETARGET = `${BASE_ACTION_CONSTANT}/MERCHANT_RETARGET`;

export const SHARE_REPORT = `${BASE_ACTION_CONSTANT}/SHARE_REPORT`;

export const COLUMNS_LIST = {
  TRANSACTIONS: {
    orderId: {
      disabled: true,
      displayText: 'Order ID',
    },
    transactionId: {
      disabled: true,
      displayText: 'Transaction ID',
    },
    name: {
      displayText: 'Name',
    },
    phoneNo: {
      displayText: 'Phone No.',
    },
    email: {
      displayText: 'Email',
    },
    orderNote: {
      displayText: 'Order Note',
    },
    currency: {
      displayText: 'Currency',
    },
    amount: {
      displayText: 'Amount',
    },
  },
};

export const HEADINGS = [
  {
    key: 'type',
    displayName: 'Type',
    width: 0.15,
  },
  {
    key: 'name',
    displayName: 'Report Name',
    width: 1.75,
  },
  {
    key: 'size',
    displayName: 'Size',
    width: 0.1,
  },
  {
    key: 'createdAt',
    displayName: 'Generated At',
    width: 0.1,
  },
  {
    key: 'generatedBy',
    displayName: 'Source',
    width: 0.1,
  },
  {
    key: 'reportStatus',
    displayName: 'Status',
    width: 0.4,
  },
  {
    key: 'reportsCTA',
    displayName: '',
    width: 0.04,
    align: 'right',
  },
];

export const GENERATE_REPORT_URL = {
  url: '/common/report/summary',
  method: 'GET',
};

export const SEARCH_GENERATED_REPORTS_URL = {
  url: '/pg/reports',
  method: 'GET',
};

export const GET_REPORT_BY_ID_URL = {
  url: '/pg/report/$report_id$',
  method: 'GET',
};

export const DOWNLOAD_REPORT_URL = {
  url: '/pg/report/$report_id$/download',
  method: 'GET',
};

export const DELETE_REPORT_URL = {
  url: '/pg/report/$report_id$',
  method: 'DELETE',
};

export const GENERATE_REPORT_URL_V2 = {
  url: '/pg/report/summary',
  method: 'GET',
};

export const GET_MERCHANT_ROUTE_REQUEST = {
  url: '/router/routes/settlement-recon-routes',
  method: 'GET',
};

export const POST_MERCHANT_SHARE_REPORT = {
  url: '/pg/report/share',
  method: 'POST',
};

export const PAYMENT_LINK_TRANSACTIONS = 'PAYMENT_LINK_TRANSACTIONS';

export const TRANSACTIONS = 'TRANSACTIONS';

export const SOFTPOS = 'softpos';

export const SETTLEMENT_RECON_V2 = 'settlement_recon_v2';

export const FLOW_WISE_RECON = 'flow_wise_recon_report';

export const REPORT_OPTIONS = [
  {
    key: 'SETTLEMENTS_RECON',
    text: 'Settlement Recon',
    value: SETTLEMENT_RECON_V2,
    fileName: 'Settlement Recon Report',
    description:
      'View all payments, refunds, disputes, adjustments, etc., associated with the settlements for the date range selected.',
    // showNewLabel: true,
    // disabled: true,
  },
  {
    key: 'FLOW_WISE_RECON',
    text: 'flowWise Recon',
    value: FLOW_WISE_RECON,
    fileName: 'FlowWise Recon Report',
    description:
      'Reconcile your settlements received against transactions, refunds, disputes, adjustments etc. processed via different PGs for the date range selected.',
  },
  {
    key: TRANSACTIONS,
    text: 'Transactions',
    value: 'transaction',
    fileName: 'Transaction Report',
    description:
      'View transaction details like Transaction ID, Status, Issuer Name and Transaction Date for the date range selected.',
  },
  {
    key: 'SETTLEMENTS',
    text: 'Settlements',
    value: 'settlement',
    fileName: 'Settlement Summary Report',
    description:
      'View settlement details like Settlement ID, Status, Date and UTR for the date range selected.',
    // disabled: true,
  },
  {
    key: 'REFUNDS',
    text: 'Refunds',
    value: 'refund',
    fileName: 'Refunds Report',
    description:
      'View refund details like refund ID, amount, date, corresponding payment ID, and more for the date range selected.',
    // disabled: true,
  },
  {
    key: 'LEDGER',
    text: 'Ledger',
    value: 'ledger',
    fileName: 'Ledger',
    description:
      'View ledger details like Ledger ID, Amount, Date, corresponding Transaction ID, and more for the date range selected.',
    // disabled: true,
  },
  {
    key: PAYMENT_LINK_TRANSACTIONS,
    text: 'Payment Link Transactions',
    value: 'transaction',
    fileName: 'Payment Link Transactions Report',
    description:
      'View payment link transaction details like Transaction ID, Order ID, Link Id, Transaction Time and Status, Customer Details, and more for the date range selected.',
    // disabled: true,
  },
  {
    key: 'PAYMENT_FORM',
    text: 'Payment Form Orders',
    value: 'paymentForm',
    fileName: 'Payment Form Report',
    description:
      'View payment form details like Order Details, Transaction Details, Settlement Details ,Card Details, Customer Details and more for the date range selected.',
    // disabled: true,
  },
  {
    key: 'PRODUCT_LINK_ORDERS',
    text: 'Product Link Orders',
    value: 'product',
    fileName: 'Product Link Orders Report',
    description:
      'View product link order details like Order Id, Product Name, Quantity, Transaction Time and Status, Customer Details, and more for the date range selected.',
    // disabled: true,
  },
  {
    key: SOFTPOS,
    text: 'softPOS Transactions',
    value: 'softpos',
    fileName: 'softPOS Transactions Report',
    description:
      'View transaction details like agent name, terminal ID, POS payment mode for the date range selected.',
    // disabled: true,
  },
  {
    key: 'PAYTM',
    text: 'Paytm',
    value: 'paytm',
    fileName: 'Paytm Report',
    description:
      'View paytm summary like Amount, Date, corresponding Transaction ID, and more for the date range selected.',
    // disabled: true,
  },
  {
    key: 'DISPUTES',
    text: 'Disputes',
    value: 'dispute_order',
    fileName: 'Disputes Report',
    description:
      'View dispute details like Dispute ID, Dispute amount, Order ID on which Dispute is created, Created On, Respond by, Dispute Status and more for the Date range selected.',
  },
  {
    key: 'SETTLEMENTS_RECON_OFFLINE',
    text: 'Settlement Recon - Offline',
    value: 'offline_settlement_recon',
    fileName: 'Offline Settlement Recon Report',
    description:
      'View all payments, refunds, disputes, adjustments, etc., associated with the settlements for the date range selected for Offline payments.',
  },
  {
    key: 'SETTLEMENTS_OFFLINE',
    text: 'Settlements - Offline',
    value: 'offline_settlement',
    fileName: 'Offline Settlement Summary Report',
    description:
      'View settlement details like Settlement ID, Status, Date and UTR for the date range selected for Offline payments.',
  },
  {
    key: 'LEDGER_OFFLINE',
    text: 'Ledger - Offline',
    value: 'offline_ledger',
    fileName: 'Offline Ledger',
    description:
      'View offline payments ledger details like Ledger ID, Amount, Date, corresponding Transaction ID, and more for the date range selected.',
  },
  {
    key: RISK_TRANSACTIONS,
    text: 'RiskShield Transactions',
    value: 'risk_transaction',
    fileName: 'RiskShield Transactions',
    description:
      'View payment details like transactionId, amount, reason of the transactions blocked by the RiskShield for the given date range.',
  },
];

export const IMPORTS_REPORT_OPTIONS = [
  {
    key: 'IMPORT_TRANSACTION',
    text: 'Payments',
    value: 'xb_import_transaction_report',
    fileName: 'Payment Report',
    description:
      'View payment details like Payment ID, Status, Issuer Name and Payment Date for the date range selected.',
  },
  {
    key: 'IMPORT_TRANSACTION_VERIFICATION',
    text: 'Payments Verification',
    value: 'xb_import_transaction_verification_report',
    fileName: 'Payment Verification Report',
    description:
      'View Payments verification details for the date range selected.',
  },
  {
    key: 'IMPORT_TRANSACTION_VERIFICATION_DOC_DETAILS',
    text: 'Payments Verification Documents Details',
    value: 'xb_import_transaction_verification_doc_details_report',
    fileName: 'Payments Verification Documents Details Report',
    description:
      'View payments verification document details for the date range selected.',
  },
  {
    key: 'IMPORT_SETTLEMENT',
    text: 'Settlements',
    value: 'xb_import_settlement_report',
    fileName: 'Settlement Summary Report',
    description:
      'View settlement details like Settlement ID, Status, Date and UTR for the date range selected.',
    // disabled: true,
  },
  {
    key: 'IMPORT_SETTLEMENT_RECON',
    text: 'Settlement Recon',
    value: 'xb_import_settlement_recon_report',
    fileName: 'Settlement Recon Report',
    description:
      'View all payments, refunds, disputes, adjustments, etc., associated with the settlements for the date range selected.',
    // showNewLabel: true,
    // disabled: true,
  },
  {
    key: 'REFUNDS',
    text: 'Refunds',
    value: 'refund',
    fileName: 'Refunds Report',
    description:
      'View refund details like refund ID, amount, date, corresponding payment ID, and more for the date range selected.',
    // disabled: true,
  },
  {
    key: 'IMPORT_LEDGER',
    text: 'Ledger',
    value: 'xb_import_ledger_report',
    fileName: 'Ledger',
    description:
      'View ledger details like Ledger ID, Amount, Date, corresponding Transaction ID, and more for the date range selected.',
    // disabled: true,
  },
  {
    key: PAYMENT_LINK_TRANSACTIONS,
    text: 'Payment Link Transactions',
    value: 'transaction',
    fileName: 'Payment Link Transactions Report',
    description:
      'View payment link transaction details like Transaction ID, Order ID, Link Id, Transaction Time and Status, Customer Details, and more for the date range selected.',
    // disabled: true,
  },
  {
    key: 'PAYMENT_FORM',
    text: 'Payment Form Orders',
    value: 'paymentForm',
    fileName: 'Payment Form Report',
    description:
      'View payment form details like Order Details, Transaction Details, Settlement Details ,Card Details, Customer Details and more for the date range selected.',
    // disabled: true,
  },
  {
    key: 'PRODUCT_LINK_ORDERS',
    text: 'Product Link Orders',
    value: 'product',
    fileName: 'Product Link Orders Report',
    description:
      'View product link order details like Order Id, Product Name, Quantity, Transaction Time and Status, Customer Details, and more for the date range selected.',
    // disabled: true,
  },
  {
    key: 'PAYTM',
    text: 'Paytm',
    value: 'paytm',
    fileName: 'Paytm Report',
    description:
      'View paytm summary like Amount, Date, corresponding Transaction ID, and more for the date range selected.',
    // disabled: true,
  },
  {
    key: 'DISPUTES',
    text: 'Disputes',
    value: 'dispute_order',
    fileName: 'Disputes Report',
    description:
      'View dispute details like Dispute ID, Dispute amount, Order ID on which Dispute is created, Created On, Respond by, Dispute Status and more for the Date range selected.',
  },
  {
    key: RISK_TRANSACTIONS,
    text: 'RiskShield Transactions',
    value: 'risk_transaction',
    fileName: 'RiskShield Transactions',
    description:
      'View payment details like transactionId, amount, reason of the transactions blocked by the RiskShield for the given date range.',
  },
];

export const VENDOR_RECON = 'VENDOR_RECON';

export const VENDOR_ORDER_RECON = 'VENDOR_ORDER_RECON';

export const VENDOR_REPORT_OPTIONS = [
  {
    key: 'VENDOR_SPLIT_SETTLEMENTS',
    text: 'Vendor Split Settlements',
    value: 'vendorSettlement',
    fileName: 'Vendor Split Settlement Summary Report',
    description:
      'View vendor split settlement details like Settlement ID, Status, Date and UTR for the date range selected.',
    // disabled: true,
  },
  {
    key: VENDOR_RECON,
    text: 'Vendor Recon',
    value: 'vendorRecon',
    fileName: 'Merchant Recon Report',
    description: 'View vendor recon details',
    // disabled: true,
  },
  {
    key: VENDOR_ORDER_RECON,
    text: 'Vendor Order Recon',
    value: 'vendorOrderRecon',
    fileName: 'Order Recon Report',
    description:
      'View all details of split orders including vendor splits, vendor split settlement status and vendor split refund details of all split orders selected.',
  },
];

export const SBC_REPORT_OPTIONS = [
  {
    key: 'SBC_PAYMENTS',
    text: 'Subscription Payments',
    value: 'subscription_payments_datalake',
    fileName: 'Subscription Payments Report',
    description:
      'View payment details like Order ID, Status, Issuer Name and Order Date for the date range selected.',
  },
  {
    key: 'SUBSCRIPTIONS',
    text: 'Subscriptions',
    value: 'subscription',
    fileName: 'Subscriptions Report',
    description:
      'View subscription details like Subscription ID, Status, Customer Name and Subscription Date for the date range selected.',
    // disabled: true,
  },
];

export const DROPDOWN_FILTERS_PAYLOAD_MAPPING = {
  pg_settlement_summary_report: 'Settlements',
  pg_ledger_summary_report: 'Ledger',
  pg_paytm_summary_report: 'Paytm',
  tx_report: 'Transactions',
  pg_settlement_recon_report: 'Settlement Recon',
  pg_settlement_recon_report_v2: 'Settlement Recon',
  pg_refund_report: 'Refunds',
  product: 'Product Link Orders',
  pg_product_txn_report: 'Product Link Orders',
  split_report: 'Vendor Split Settlements',
  split_txn: 'Vendor Settlement Recon',
  pg_payment_form_report: 'Payment Form Orders',
  softpos: 'softPOS Transactions',
  vendor_recon_report: 'Vendor Recon',
  subscription: 'Subscription',
  subscription_payments_datalake: 'Subscription Payments',
  redemption_order: 'Offers',
  dispute_order: 'Disputes',
  vendor_order_recon: 'Vendor Order Recon',
  flow_wise_recon_report: 'Flowise Recon',
  offline_settlement_summary_report: 'Offline Settlement',
  offline_settlement_recon: 'Offline Settlement Recon',
  offline_ledger_summary_report: 'Offline Ledger',
  retarget_order: 'Abandoned Orders',
  risk_transaction: 'RiskShield Transactions',
  xb_import_transaction_report: 'Payments',
  xb_import_transaction_verification_report: 'Payments Verification',
  xb_import_transaction_verification_doc_details_report:
    'Payments Verification Documents Details',
  xb_import_settlement_report: 'Settlements',
  xb_import_settlement_recon_report: 'Settlements Recon',
  xb_import_ledger_report: 'Ledger',
};

export const PAYMENT_LINK_TXN_STATUS = [
  'SUCCESS',
  'FAILED',
  'USER_DROPPED',
  'INCOMPLETE',
];

export const DONE = 'DONE';
export const SHARE = 'SHARE';

export const REQUESTED = 'REQUESTED';

export const ERROR = 'ERROR';

export const PROCESSING = 'PROCESSING';

export const DELETE = 'DELETE';

export const MENU_ITEMS = [
  { key: ICON_NAME.DOWNLOAD_OUTLINE, text: 'Download Report', value: DONE },
  { key: ICON_NAME.REFRESH, text: 'Refresh Report', value: REQUESTED },
  { key: ICON_NAME.SHARE, text: 'Share Report', value: SHARE },
  {
    key: ICON_NAME.DELETE_SPLIT,
    text: 'Delete Report',
    value: DELETE,
  },
];

export const RETARGET_OPTIONS = [
  {
    key: 'RETARGET_ORDER',
    text: 'Abandoned Orders',
    value: 'retarget_order',
    fileName: 'Abandoned Orders Report',
    description:
      'View abandoned orders details and conversion status via Whatsapp / SMS for the date range selected',
    // disabled: true,
  },
];
